import axios from "@/utils/api.request"

export const getAllMaps = () => {
    return axios.request({
        url: '/api/common/map',
        method: 'get'
    })
}


/**
 * 获取上传令牌
 */
export const getTosToken = async (params) => {
    return axios.request({
        url: '/api/system/tos_token',
        method: 'GET',
        params
    })
}